import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { TopMobileBannerProps } from './'

export const TopMobileBannerType = ComponentTypeFactory.create<TopMobileBannerProps>(
  'TopMobileBanner',
  {
    image: FieldTypeFactory.image(),
    url: FieldTypeFactory.text(),
    imageWidth: FieldTypeFactory.number(),
    imageHeight: FieldTypeFactory.number(),
    alt: FieldTypeFactory.text(),
  }
)
